import React from 'react';
import TestimonialsCard from './testimonialsCard';
import { Pagination, Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css/pagination';
import 'swiper/css';

const TestimonialSlider = ({ data, displayOnMobile }) => {
	return (
		data?.checkout_v3_testimonials_reviews && (
			<>
				<article
					className={
						displayOnMobile
							? 'sliderContainer sliderContainer--mobile'
							: 'sliderContainer sliderContainer--desktop'
					}
				>
					<div style={{ position: 'relative' }}>
						<Swiper
							modules={[Pagination, Autoplay]}
							spaceBetween={0}
							slidesPerView={1}
							loop={true}
							autoplay={{
								delay: 4500,
								disableOnInteraction: true,
							}}
							pagination={{ clickable: true }}
							scrollbar={{ draggable: true }}
						>
							{data?.checkout_v3_testimonials_reviews.map((card, index) => {
								return (
									<SwiperSlide className="carousel" key={index}>
										<TestimonialsCard
											reviewerName={card.checkout_v3_testimonial_author}
											reviewerImg={card.checkout_v3_testimonial_reviewer}
											rating={card.checkout_v3_testimonial_stars}
											daysAgo={card.checkout_v3_testimonial_daysAgo}
											country={data.tr_checkout_v3_testimonials_country}
											countryImg={data.checkout_v3_testimonials_flag}
											title={card.tr_checkout_v3_testimonial_title}
											description={card.tr_checkout_v3_testimonial_description}
											reviewLabel={data.tr_checkout_v3_testimonials_verifiedLabel}
										/>
									</SwiperSlide>
								);
							})}
						</Swiper>
					</div>
					<div className="swiper-pagination swiper-pagination-bullets"></div>
				</article>
			</>
		)
	);
};

export default TestimonialSlider;
